import { backUrl } from "../utils/backURL";
import { apiFetch } from "../utils/apiFetch";

// Mantis Conversations API calls
export const getMantisConversations = async (token, filters = {}) => {
  try {
    const queryParams = new URLSearchParams(filters).toString();
    const url = queryParams ? `${backUrl}/mantis-conversations?${queryParams}` : `${backUrl}/mantis-conversations`;
    
    const response = await apiFetch(url, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error fetching mantis conversations:", error);
    throw error;
  }
};

export const getMantisConversationById = async (token, conversationId) => {
  try {
    const response = await apiFetch(`${backUrl}/mantis-conversations/${conversationId}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error fetching mantis conversation:", error);
    throw error;
  }
};

export const createMantisConversation = async (token, conversationData) => {
  try {
    const response = await apiFetch(`${backUrl}/mantis-conversations`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(conversationData),
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error creating mantis conversation:", error);
    throw error;
  }
};

export const updateMantisConversation = async (token, conversationId, updateData) => {
  try {
    const response = await apiFetch(`${backUrl}/mantis-conversations/${conversationId}`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(updateData),
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error updating mantis conversation:", error);
    throw error;
  }
};

export const deleteMantisConversation = async (token, conversationId) => {
  try {
    const response = await apiFetch(`${backUrl}/mantis-conversations/${conversationId}`, {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error deleting mantis conversation:", error);
    throw error;
  }
};

export const getMantisConversationsByBusinessId = async (token, businessId, filters = {}) => {
  try {
    const queryParams = new URLSearchParams(filters).toString();
    const url = queryParams ? `${backUrl}/mantis-conversations/business/${businessId}?${queryParams}` : `${backUrl}/mantis-conversations/business/${businessId}`;
    
    const response = await apiFetch(url, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error fetching conversations by business:", error);
    throw error;
  }
};

export const getMantisConversationsByAgentId = async (token, agentId, filters = {}) => {
  try {
    const queryParams = new URLSearchParams(filters).toString();
    const url = queryParams ? `${backUrl}/mantis-conversations/agent/${agentId}?${queryParams}` : `${backUrl}/mantis-conversations/agent/${agentId}`;
    
    const response = await apiFetch(url, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error fetching conversations by agent:", error);
    throw error;
  }
};

export const getMantisConversationsByChannel = async (token, channel, filters = {}) => {
  try {
    const queryParams = new URLSearchParams(filters).toString();
    const url = queryParams ? `${backUrl}/mantis-conversations/channel/${channel}?${queryParams}` : `${backUrl}/mantis-conversations/channel/${channel}`;
    
    const response = await apiFetch(url, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error fetching conversations by channel:", error);
    throw error;
  }
};

export const updateMantisConversationStatus = async (token, conversationId, status) => {
  try {
    const response = await apiFetch(`${backUrl}/mantis-conversations/${conversationId}/status`, {
      method: "PATCH",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({ status }),
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error updating conversation status:", error);
    throw error;
  }
};

export const assignAgentToMantisConversation = async (token, conversationId, agentId) => {
  try {
    const response = await apiFetch(`${backUrl}/mantis-conversations/${conversationId}/assign-agent`, {
      method: "PATCH",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({ agentId }),
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error assigning agent to conversation:", error);
    throw error;
  }
};

// Mantis Conversation Sessions API calls
export const getMantisConversationSessions = async (token, filters = {}) => {
  try {
    const queryParams = new URLSearchParams(filters).toString();
    const url = queryParams ? `${backUrl}/mantis-conversation-sessions?${queryParams}` : `${backUrl}/mantis-conversation-sessions`;
    
    const response = await apiFetch(url, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error fetching conversation sessions:", error);
    throw error;
  }
};

export const getMantisConversationSessionsByConversationId = async (token, conversationId) => {
  try {
    const response = await apiFetch(`${backUrl}/mantis-conversation-sessions/conversation/${conversationId}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error fetching sessions by conversation:", error);
    throw error;
  }
};

export const getActiveMantisConversationSession = async (token, conversationId) => {
  try {
    const response = await apiFetch(`${backUrl}/mantis-conversation-sessions/conversation/${conversationId}/active`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error fetching active session:", error);
    throw error;
  }
};

export const createMantisConversationSession = async (token, sessionData) => {
  try {
    const response = await apiFetch(`${backUrl}/mantis-conversation-sessions`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(sessionData),
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error creating conversation session:", error);
    throw error;
  }
};

export const updateMantisConversationSession = async (token, sessionId, updateData) => {
  try {
    const response = await apiFetch(`${backUrl}/mantis-conversation-sessions/${sessionId}`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(updateData),
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error updating conversation session:", error);
    throw error;
  }
};

export const closeMantisConversationSession = async (token, sessionId) => {
  try {
    const response = await apiFetch(`${backUrl}/mantis-conversation-sessions/${sessionId}/close`, {
      method: "PATCH",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error closing conversation session:", error);
    throw error;
  }
};

// Mantis Conversation Messages API calls
export const getMantisConversationMessages = async (token, filters = {}) => {
  try {
    const queryParams = new URLSearchParams(filters).toString();
    const url = queryParams ? `${backUrl}/mantis-conversation-messages?${queryParams}` : `${backUrl}/mantis-conversation-messages`;
    
    const response = await apiFetch(url, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error fetching conversation messages:", error);
    throw error;
  }
};

export const getMantisConversationMessagesByConversationId = async (token, conversationId, limit = 50, offset = 0) => {
  try {
    const response = await apiFetch(`${backUrl}/mantis-conversation-messages/conversation/${conversationId}?limit=${limit}&offset=${offset}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error fetching messages by conversation:", error);
    throw error;
  }
};

export const getMantisConversationMessagesBySessionId = async (token, sessionId, limit = 50, offset = 0) => {
  try {
    const response = await apiFetch(`${backUrl}/mantis-conversation-messages/session/${sessionId}?limit=${limit}&offset=${offset}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error fetching messages by session:", error);
    throw error;
  }
};

export const getMantisConversationMessagesByChannel = async (token, channel, limit = 50, offset = 0) => {
  try {
    const response = await apiFetch(`${backUrl}/mantis-conversation-messages/channel/${channel}?limit=${limit}&offset=${offset}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error fetching messages by channel:", error);
    throw error;
  }
};

export const createMantisConversationMessage = async (token, messageData) => {
  try {
    const response = await apiFetch(`${backUrl}/mantis-conversation-messages`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(messageData),
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error creating conversation message:", error);
    throw error;
  }
};

export const updateMantisConversationMessage = async (token, messageId, updateData) => {
  try {
    const response = await apiFetch(`${backUrl}/mantis-conversation-messages/${messageId}`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(updateData),
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error updating conversation message:", error);
    throw error;
  }
};

export const updateMantisConversationMessageStatus = async (token, messageId, status, additionalData = {}) => {
  try {
    const response = await apiFetch(`${backUrl}/mantis-conversation-messages/${messageId}/status`, {
      method: "PATCH",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({ status, ...additionalData }),
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error updating message status:", error);
    throw error;
  }
};

export const getMantisConversationMessageStats = async (token, filters = {}) => {
  try {
    const queryParams = new URLSearchParams(filters).toString();
    const url = queryParams ? `${backUrl}/mantis-conversation-messages/stats/summary?${queryParams}` : `${backUrl}/mantis-conversation-messages/stats/summary`;
    
    const response = await apiFetch(url, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error fetching message stats:", error);
    throw error;
  }
};
